import { Card } from '@ace-clublabs/shared-component-library';
import { CardHeader } from './CardHeader';
import { CardItems } from './CardItems';
import { CardButton } from './CardButton';
import { CardBanner } from './CardBanner';
import { ScheduledPaymentBanner } from './ScheduledPaymentBanner';

export const PaymentCard = () => {
  return (
    <div className="payment-card-section">
      <Card
        cardType="GenericCard"
        sx={{
          width: '100% !important',
          maxWidth: '554px',
          padding: '0',
          marginTop: '1.875rem',
          '@media (min-width: 768px)': { width: '391px' },
          '@media (max-width: 769px)': { marginTop: '1rem' },
        }}
      >
        <CardBanner />
        <ScheduledPaymentBanner />
        <CardHeader />
        <CardItems />
        <CardButton />
      </Card>
    </div>
  );
};
